import { defineStore } from 'pinia';
import type { TalentSearchGating } from './types/talent-search-gating.type';
import { ref } from 'vue';
import type { ATSEmployerSubscription } from '@factoryfixinc/ats-interfaces';

export const useSubscriptionStore = defineStore('subscription', () => {
  const subscriptionProductName = ref<string>();
  const subscription = ref<ATSEmployerSubscription>();
  const talentSearchGating = ref<TalentSearchGating>();
  const jobsCount = ref<number>(0);
  // Distinguishes "no subscription on file" from "not fetched yet" — an
  // undefined subscription alone must never be read as expired. Covers both
  // the v1 and v2 fetch paths.
  const isLoaded = ref<boolean>(false);

  // alphabetized list
  return {
    isLoaded,
    jobsCount,
    subscription,
    subscriptionProductName,
    talentSearchGating,
  };
});
